import { render } from "./OldViewTemplate.vue?vue&type=template&id=0a5cc4e1&scoped=true"
import script from "./OldViewTemplate.vue?vue&type=script&lang=js"
export * from "./OldViewTemplate.vue?vue&type=script&lang=js"

import "./OldViewTemplate.vue?vue&type=style&index=0&id=0a5cc4e1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a5cc4e1"]])

export default __exports__